"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueSuggestionDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class VenueSuggestionDto {}
exports.VenueSuggestionDto = VenueSuggestionDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSuggestionDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSuggestionDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'No longer collected from the user; may be filled in by an admin on approval'
}), __metadata("design:type", Object)], VenueSuggestionDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSuggestionDto.prototype, "comment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSuggestionDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSuggestionDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueSuggestionStatus
}), __metadata("design:type", String)], VenueSuggestionDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSuggestionDto.prototype, "submittedByName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSuggestionDto.prototype, "submittedByEmail", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSuggestionDto.prototype, "reviewedByName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSuggestionDto.prototype, "reviewedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'publicId of the venue created when this suggestion was approved'
}), __metadata("design:type", Object)], VenueSuggestionDto.prototype, "createdVenuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'publicId of the feedback topic (support comment) opened for this suggestion'
}), __metadata("design:type", String)], VenueSuggestionDto.prototype, "commentPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSuggestionDto.prototype, "createdAt", void 0);
//# sourceMappingURL=VenueSuggestion.dto.js.map